/*eslint-disable no-undef */
import phina from 'phina.js'
import './include'
import './extend'

let canvasInit = function () {
  var arg = {}
  var pair = location.search.substring(1).split('&')
  for (var i = 0; pair[i]; i++) {
    var kv = pair[i].split('=')
    arg[kv[0]] = kv[1]
  }
  var scale = parseFloat(arg['scale']) || 1.0
  var app = phina.display.CanvasApp({
    query: '#game',
    width: Math.floor(1000 * scale),
    height: Math.floor(600 * scale),
    // fit: arg['fit'] === undefined ? true : arg['fit'] === 'true',
    fit: false,
    fps: arg['fps'] || 20
  })
  //    app.backgroundColor = "#efeade";
  app.backgroundColor = '#ccc'
  if (arg['fit'] === 'true') {
    // do nothing
  } else if (arg['fit'] === 'once') {
    app.canvas.fitScreen(false)
  // }else{
    // document.getElementById('mainContent').style.margin = '40px';
  }
  app.domElement.style.imageRendering = 'crisp-edge'

  var loader = phina.asset.AssetLoader();
  loader.load({
    image:{
        "noimage": "img/noimage.png",
        "img/ui/bg.png": "img/ui/bg.png",
        "img/ui/bg2.png": "img/ui/bg2.png",
        "img/ui/paper.png": "img/ui/paper.png",
        // "map1": "img/map.png",
        // "img/ui/btn1_c1.png": "img/ui/btn1_c1.png",
        // "img/ui/btn1_c2.png": "img/ui/btn1_c2.png",
        // "img/ui/btn1_l1.png": "img/ui/btn1_l1.png",
        // "img/ui/btn2.png": "img/ui/btn2.png",
        "img/title.png": "img/title.png",
        "img/title2.png": "img/title2.png",
        // "img/ui/frame3.png": "img/ui/frame3.png",
        // "img/ui/frame_bg1.png": "img/ui/frame_bg1.png",
        "img/ui/header_bg1.png": "img/ui/header_bg1.png",
        "img/ui/loading.gif": "img/ui/loading.gif",
        // "img/ui/at.png": 'img/ui/at.png',
        // "img/ui/df.png": 'img/ui/df.png',
        // "img/ui/mt.png": 'img/ui/mt.png',
        // "img/ui/sd.png": 'img/ui/sd.png',
        // "sorry001": "img/npc/bull-dog/bad-dog.png",
        // "bar1": "img/ui/bar1.png",
        // "frame1": "img/ui/frame1.png",
        // "frame2": "img/ui/frame2.png",
    },
    pixiimage:{
      "img/effect/HardRain.png": "img/effect/HardRain.png",
    }
  });
  loader.onload = function(){
    app.replaceScene(MyManagerScene({scale:scale}));
    !!arg['debug'] && app.enableStats();
    app.run()
    app.flare('started')
  };

  phina.global && (phina.global.app = app)
}

export { phina, canvasInit }
